import { render } from "./SimpleText.vue?vue&type=template&id=0a9f67ab"
import script from "./SimpleText.vue?vue&type=script&lang=js"
export * from "./SimpleText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__